import React, {Component} from 'react'
import PropTypes from 'prop-types'
import GridComponent from './Grid.component'
import uniqBy from 'lodash/uniqBy'

class GridContainer extends Component {
    static propTypes = {
      gridWidth: PropTypes.number,
      api: PropTypes.object,
      env: PropTypes.object,
      handleSort: PropTypes.func
    }

    constructor(props) {
      super(props)

      this.state = {
        selectedRows: [],
        selectiveMultiSelectRows: props.data,
        openParentRows: [],
        headerChecked: false
      }

      if (props.multiselect && props.multiselect.selective && props.multiselect.selective.callback) {
        this.state.selectiveMultiSelectRows = this.hasSelectiveRows(props.multiselect.selective.callback, props.data)
      }
    }

    componentWillReceiveProps(props) {
      if (props.selectedRows && props.selectedRows.length === 0) {
        this.setState({
          selectedRows: []
        })
      }
      // use external callback to check if row should contain multiselect checkbox or not
      if (props.multiselect && props.multiselect.selective) {
        const selectiveMultiSelectRows = this.hasSelectiveRows(props.multiselect.selective.callback, props.data)

        this.setState({
          selectiveMultiSelectRows
        })
      }
    }

    hasSelectiveRows(callback, data) {
      return this.props.env.callFunction(callback, [data])
    }

    /**
     *
     * @param {Boolean} selectAllState
     *
     * Sets and unsets select all checkboxes
     */
    handleSelectAll = (selectAllState) => {
      let selectedRows = []
      const subSelectedRows = []
      let filteredrowstodownload = []

      if (selectAllState) {
        filteredrowstodownload = this.props.api.getFilteredItems()
        selectedRows = filteredrowstodownload.map((dataRow) => {
          if (this.props.subRows) {
            if (dataRow[this.props.subRows.datafield] && dataRow[this.props.subRows.datafield].length > 0) {
              dataRow[this.props.subRows.datafield].forEach((subDataRow) => {
                subSelectedRows.push(subDataRow.uuid)
              })
            }
          }
          return dataRow.uuid
        })
      }

      selectedRows = selectedRows.concat(subSelectedRows)

      // build up array of selected rows and sub rows to send to callback
      const selectedSubDataRows = []
      const rowsSelected = selectAllState ? filteredrowstodownload : this.state.selectiveMultiSelectRows
      const selectedDataRows = rowsSelected.filter((selectedRow) => {
        // If there are sub rows AND the row is selected, push onto the selectedSubRows array

        if (this.props.subRows) {
          if (selectedRow[this.props.subRows.datafield] && selectedRow[this.props.subRows.datafield].length > 0 && selectedRows.indexOf(selectedRow.uuid) > -1) {
            selectedRow[this.props.subRows.datafield].forEach((subDataRow) => {
              selectedSubDataRows.push(subDataRow)
            })
          }
        }

        return selectedRows.indexOf(selectedRow.uuid) > -1
      })

      // if callback, invoke it
      if (this.props.multiselect.event && this.props.multiselect.event.callback) {
        this.props.env.callFunction(this.props.multiselect.event.callback, [selectedDataRows.concat(selectedSubDataRows), selectAllState])
      }

      this.props.setSelectedRows(selectedDataRows.concat(selectedSubDataRows), selectAllState)

      this.setState({
        selectedRows,
        headerChecked: selectAllState
      })

      
    }

    /**
     *
     * @param {Boolean} selectState
     * @param {Object} row
     *
     * Sets/unsets individual checkbox
     */
    handleMultiSelectChanged = (selectState, dataRow) => {
      this.setState({
        headerChecked: false
      })

      const uuid = dataRow.uuid

      let selectedRows = this.state.selectedRows
      const unselectedRows = []
      let subRows = []

      if (this.props.subRows) {
        if (dataRow[this.props.subRows.datafield] && dataRow[this.props.subRows.datafield].length > 0) {
          subRows = dataRow[this.props.subRows.datafield].map((subRow) => {
            return subRow.uuid
          })
        }
      }

      if (!selectState) {
        selectedRows = selectedRows.filter((selectedRow) => {
          return selectedRow !== uuid && subRows.indexOf(selectedRow) < 0
        })

        unselectedRows.push(uuid)
      } else {
        selectedRows.push(uuid)
        selectedRows = selectedRows.concat(subRows)
      }

      // Get subset of rows to use as data binding
      const selectedSubDataRows = []
      let selectedDataRows = this.props.api.getFilteredItems().filter((selectedRow) => {
        if (this.props.subRows) {
          if (selectedRow[this.props.subRows.datafield] && selectedRow[this.props.subRows.datafield].length > 0) {
            let hasSelectedRow = false

            // if parent row is selected (newly selected, based on dataRow uuid), select all sub children (unless deliberately unselected)
            if (selectedRows.indexOf(selectedRow.uuid) > -1 && selectedRow.uuid === dataRow.uuid) {
              hasSelectedRow = true
              selectedRow[this.props.subRows.datafield].forEach((subDataRow) => {
                if (unselectedRows.indexOf(subDataRow.uuid) < 0) {
                  selectedSubDataRows.push(subDataRow)
                }
              })
            }
            // loop again through children, and see if any match any selected
            if (!hasSelectedRow) {
              selectedRow[this.props.subRows.datafield].forEach((subDataRow) => {
                if (selectedRows.indexOf(subDataRow.uuid) > -1 && unselectedRows.indexOf(subDataRow.uuid) < 0) {
                  selectedSubDataRows.push(subDataRow)
                }
              })
            }
          }
        }

        return selectedRows.indexOf(selectedRow.uuid) > -1
      })

      selectedDataRows = selectedDataRows.concat(selectedSubDataRows)
      let currentlySelectedDataRows = []

      if (selectState) {
        currentlySelectedDataRows = selectedDataRows.concat(this.props.api.getSelectedRows().filter((item) => {
          return selectedDataRows.indexOf(item) < 0
        }))
        currentlySelectedDataRows = uniqBy(currentlySelectedDataRows, 'uuid')
      } else {
        currentlySelectedDataRows = this.props.api.getSelectedRows().filter((selectedRow) => {
          return selectedRow.uuid !== dataRow.uuid
        })
      }

      // if external global callback provided, invoke it with array of currently selected rows
      if (this.props.multiselect.event && this.props.multiselect.event.callback) {
        this.props.env.callFunction(this.props.multiselect.event.callback, currentlySelectedDataRows, true)
      }

      this.props.setSelectedRows(currentlySelectedDataRows)

      this.setState({
        selectedRows
      })
    }

    /**
     *
     * @param {Boolean} subrowState
     * @param {String (uuid)} uuid
     *
     * opens closes sub row based on uuid of parent row
     */
    handleSubRowChanged = (subrowState, uuid) => {
      let openParentRows = this.state.openParentRows

      if (!subrowState) {
        openParentRows = openParentRows.filter((openParentRow) => {
          return uuid !== openParentRow
        })
      } else {
        openParentRows.push(uuid)
      }

      this.setState({
        openParentRows
      })
    }

    render() {
      const styles = {
        width: this.props.gridWidth + 'px'
      }

      const {
        env,
        api,
        analytics,
        data,
        rowFlag,
        multiselect,
        rowActions,
        subRows,
        freezeCol,
        headers,
        multiLineRow,
        scrollOffset,
        handleSort,
        datasetWidth,
        i18n,
        handleFilter,
        serverRequestInFlight
      } = this.props

      const {
        selectedRows,
        selectiveMultiSelectRows,
        openParentRows,
        headerChecked
      } = this.state

      const events = {
        handleSelectAll: this.handleSelectAll,
        handleMultiSelectChanged: this.handleMultiSelectChanged,
        handleSubRowChanged: this.handleSubRowChanged
      }

      return (
        <GridComponent
          serverRequestInFlight={serverRequestInFlight}
          env={env}
          i18n={i18n}
          api={api}
          analytics={analytics}
          style={styles}
          handleSort={handleSort}
          handleFilter={handleFilter}
          events={events}
          data={data}
          rowFlag={rowFlag}
          multiselect={multiselect}
          selectiveMultiSelectRows={selectiveMultiSelectRows}
          openParentRows={openParentRows}
          rowActions={rowActions}
          subRows={subRows}
          freezeCol={freezeCol}
          headers={headers}
          multiLineRow={multiLineRow}
          scrollOffset={scrollOffset}
          selectedRows={selectedRows}
          datasetWidth={datasetWidth}
          headerChecked={headerChecked}
        />
      )
    }
}

export default GridContainer
